import { useEffect, useState } from 'react'

import { Book, Category } from '@apis/index'
import BackNavigation from '@components/backNavigation'
import Button from '@components/button'
import Fields from '@components/fields'
import useWindowSize from '@hooks/useWindow'
import { BookSchema } from '@validations/index'
import { Form, Formik } from 'formik'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import {
  CoverImageWrapper,
  CreateBookContainer,
  FieldsRow,
  FormWrapper,
  StyleCreateBookForm,
  StyleFixedButton,
  ThumbnailsRow,
  UploadImagesContainer,
} from './style'

const CreateBook = () => {
  const { width } = useWindowSize()
  const navigate = useNavigate()
  const { id: bookId } = useParams()
  const { state: book } = useLocation()
  const [loading, setLoading] = useState(false)
  const { data: booksCategories } = useSelector(
    (state: any) => state.bookCategories,
  )
  const fetchBookCategories = async () => {
    await Category.getAll({}).catch(() => {})
  }
  useEffect(() => {
    if (!booksCategories?.length) fetchBookCategories()
  }, [booksCategories?.length])

  const [initialValues, setInitialValues] = useState({
    bookName: '',
    author: '',
    category: '',
    desc: '',
    coverImg: null,
    images1: null,
    images2: null,
    images3: null,
    images4: null,
  })

  useEffect(() => {
    if (bookId && book?.id)
      setInitialValues({
        ...initialValues,
        bookName: book?.name,
        category: book?.category,
        author: book?.author,
        desc: book?.description,
        coverImg: book?.coverImage || null,
        images1: book?.additionalImages?.[0]?.images || null,
        images2: book?.additionalImages?.[1]?.images || null,
        images3: book?.additionalImages?.[2]?.images || null,
        images4: book?.additionalImages?.[3]?.images || null,
      })
  }, [])

  const submitHandler = async (values: any) => {
    setLoading(true)

    const payload: any = {
      name: values?.bookName,
      author: values?.author,
      description: values?.desc,
      category: values?.category,
    }

    if (values?.coverImg?.base64) {
      payload.coverImage = {
        extension: values?.coverImg?.extension,
        base64: values?.coverImg?.base64,
      }
    }

    const images = []
    const imageFields = ['images1', 'images2', 'images3', 'images4']
    imageFields.forEach((field, index) => {
      const image = values?.[field]

      if (image?.base64) {
        const imagePayload: any = {
          extension: image.extension,
          base64: image.base64,
        }

        if (book?.additionalImages[index]) {
          imagePayload.id = book?.additionalImages[index]?.id
        }
        images.push(imagePayload)
      }
    })

    if (images?.length) {
      payload.images = images
    }

    if (bookId && book?.id) {
      await Book.updateBook(payload, Number(bookId))
        .then((resp) => {
          navigate(`/books/my-books/${resp.name}/${resp.id}`)
        })
        .catch(() => {})
        .finally(() => {
          setLoading(false)
        })
    } else {
      await Book.createBook(payload)
        .then((resp) => {
          navigate(`/books/my-books/${resp.name}/${resp.id}`)
        })
        .catch(() => {})
        .finally(() => {
          setLoading(false)
        })
    }
  }

  const mobile = width < 1024

  return (
    <>
      <BackNavigation title={`${!!bookId ? 'Update Book' : 'Create Book'}`} />
      <CreateBookContainer>
        <FormWrapper>
          <Formik
            initialValues={initialValues}
            onSubmit={submitHandler}
            enableReinitialize
            validationSchema={BookSchema.createBookValidationSchema}
          >
            {({ handleSubmit, setFieldValue, values }: any) => (
              <Form onSubmit={handleSubmit}>
                <StyleCreateBookForm>
                  <UploadImagesContainer>
                    <CoverImageWrapper>
                      <Fields.Upload
                        name="coverImg"
                        varient="galleryCard"
                        placeholder="Upload Book Cover"
                        size={mobile ? 350 : 400}
                      />
                    </CoverImageWrapper>
                    <ThumbnailsRow>
                      <Fields.Upload
                        name="images1"
                        varient="galleryCard"
                        placeholder="Upload"
                        size={mobile ? 75 : 90}
                        onChange={(info) => {
                          setFieldValue('image1', {
                            id: values?.image1?.id,
                            base64: info?.base64,
                            extension: info?.extension,
                          })
                        }}
                      />
                      <Fields.Upload
                        name="images2"
                        varient="galleryCard"
                        placeholder="Upload"
                        size={mobile ? 75 : 90}
                      />
                      <Fields.Upload
                        name="images3"
                        varient="galleryCard"
                        placeholder="Upload"
                        size={mobile ? 75 : 90}
                      />
                      <Fields.Upload
                        name="images4"
                        varient="galleryCard"
                        placeholder="Upload"
                        size={mobile ? 75 : 90}
                      />
                    </ThumbnailsRow>
                  </UploadImagesContainer>

                  <Fields.Input
                    name="bookName"
                    label="Book Name"
                    placeholder="Book Name"
                  />

                  <FieldsRow>
                    <Fields.DropDown
                      name="category"
                      options={booksCategories}
                      titleAsKey="name"
                      valueAsKey="id"
                      label="Select Book Category"
                      styleWrapper="width:100%"
                    />
                    <Fields.Input
                      name="author"
                      label="Author Name"
                      placeholder="Author Name"
                    />
                  </FieldsRow>

                  <Fields.TextArea
                    name="desc"
                    label="Description"
                    placeholder="Description..."
                    styleInput="height: 200px; "
                  />

                  {!mobile ? (
                    <Button
                      type="submit"
                      title={`${!!bookId ? 'Update Book' : 'Create Book'}`}
                      loading={loading}
                      styleButton="margin-top: 20px;"
                    />
                  ) : (
                    <StyleFixedButton>
                      <Button
                        type="submit"
                        title={`${!!bookId ? 'Update Book' : 'Create Book'}`}
                        loading={loading}
                      />
                    </StyleFixedButton>
                  )}
                </StyleCreateBookForm>
              </Form>
            )}
          </Formik>
        </FormWrapper>
      </CreateBookContainer>
    </>
  )
}

export default CreateBook
